import React from 'react'
import { Outlet } from 'react-router-dom'

const MainInvoicesProjectIncoming = () => {
  return (
    <div className='w-full h-full'>
        <Outlet/>
    </div>
  )
}

export default MainInvoicesProjectIncoming